/**
 * Thrown only for structural failures: an unreadable file, an empty
 * table, an unsupported format. Data-level problems are IoIssues on a
 * result, never exceptions. The message is user-presentable; the raw
 * parser error, when there is one, rides in `detail`.
 */
export class IoError extends Error {
    issues;
    constructor(issue) {
        super(issue.message);
        this.name = 'IoError';
        this.issues = [issue];
    }
}
export function parseFailure(formatLabel, cause) {
    const detail = cause instanceof Error ? cause.message : String(cause);
    return new IoError({
        code: 'IO_PARSE_FAILED',
        severity: 'error',
        message: `This file could not be read as a ${formatLabel} file. Check that the file is complete and in the format its name suggests.`,
        detail,
    });
}
export function unsupportedFormat(detail) {
    return new IoError({
        code: 'IO_UNSUPPORTED_FORMAT',
        severity: 'error',
        message: 'This file type is not supported. Use an SPSS .sav, Stata .dta, SAS .sas7bdat or .xpt, Excel .xlsx, or CSV file.',
        detail,
    });
}
//# sourceMappingURL=errors.js.map